<div class="row">
  <div class="col-md-6">
    <p-datepicker
      [(ngModel)]="from"
      dateFormat="{{ dateFormat }}"
      [inputStyle]="style"
      [minDate]="minStartDate"
      [maxDate]="maxStartDate"
      [showIcon]="false"
    ></p-datepicker>
  </div>
  <div class="col-md-6">
    <p-datepicker
      [(ngModel)]="to"
      dateFormat="{{ dateFormat }}"
      [inputStyle]="style"
      [minDate]="minEndDate"
      [maxDate]="maxEndDate"
      [showIcon]="false"
    ></p-datepicker>
  </div>
</div>
